module.exports = __webpack_public_path__ + "static/media/pandemic_alert.96111ef0.png";